export const WEIK_CUSTOM_EVENT: string = "weikCustomEvent";
export const WEIK_CUSTOM_ERROR: string = "weikCustomError";